import classNames from "classnames/bind";
import Button from "common/blocks/Button";
import useModalContext from "common/providers/modal/useModalContext";
import { Extra } from "features/vehicleDetails/components/VehicleDetails/components/IncludedExtras";

import styles from "./PackModal.module.scss";

const cx = classNames.bind(styles);

const PackModal = (props: Extra) => {
    const { usePopup } = useModalContext();
    const { closePopup } = usePopup();

    return (
        <div className={cx("packModal")}>
            <ul className={cx("contentsList")}>
                {props?.contents?.map((item) => (
                    <li className={cx("contentItem")} key={item}>
                        {item}
                    </li>
                ))}
            </ul>
            <div className={cx("buttonRow")}>
                <Button onClick={() => closePopup()} fullWidth theme="primary" ariaLabel="Close">
                    Done
                </Button>
            </div>
        </div>
    );
};

export default PackModal;
